export const checkMobileVersion = (): boolean => {
  const mediaQuery = '(max-width: 768px)'
  const isMobile = matchMedia(mediaQuery).matches

  return isMobile
}

export const checkAnimationReduce = (): boolean => {
  const mediaQuery = '(prefers-reduced-motion: reduce)'
  const isAnimationReduce = matchMedia(mediaQuery).matches

  return isAnimationReduce
}
